/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Player playback state
 */
export enum PlayerAdapterPlaybackState {
	IDLE = 'idle',
	STOPPED = 'stopped',
	PLAYING = 'playing',
	PAUSED = 'paused',
	WAITING = 'waiting'
}